import React from 'react'
var genRandomValue = function () {
  return Array.from({ length: 36 }, function () {
    return Math.random().toString(36)[2]
  }).join('')
}
/**
 * 매우 복잡하게 구성된 global key 생성기이다.
 *
 * global key 의 목표는 globally 특정 리소스를 가르킬 수 있도록 하기 위함이며,
 * 이런 복잡한 hook 이 필요한 이유는 global key 를 생략해도 문제 없이 동작할 수 있도록 하기 위함이다.
 */
export function useGlobalKeys(fn) {
  var v = React.useState(function () {
    return fn().map(function (givenValue) {
      if (givenValue) {
        return givenValue
      }
      return genRandomValue()
    })
  })[0]
  return v
}
//# sourceMappingURL=useGlobalKeys.js.map
